import { IResponse } from "models";

export enum ActionType {
  MINI_STRESS_LAST_NOTIFICATION_TIME = "action/MINI_STRESS_LAST_NOTIFICATION_TIME",
  MINI_STRESS_LAST_NOTIFICATION_TIME_SUCCESS = "action/MINI_STRESS_LAST_NOTIFICATION_TIME_SUCCESS",
  MINI_STRESS_LAST_NOTIFICATION_TIME_ERROR = "action/MINI_STRESS_LAST_NOTIFICATION_TIME_ERROR",
  MINI_STRESS_LAST_NOTIFICATION_TIME_RESET = "action/MINI_STRESS_LAST_NOTIFICATION_TIME_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IMiniStressLastNotificationTimeResponse extends IResponse {
  result: {
    last_reminder_notification_at: string;
  };
}
